import { cn } from '../../utils/cn';

export interface BrandWordmarkProps {
  /** `onDark` for Prussian surfaces (navigation rail, sign-in panel). */
  tone?: 'onLight' | 'onDark';
  size?: 'sm' | 'md' | 'lg';
  /** Approved logo artwork for this tone; without it the typographic wordmark is drawn. */
  src?: string;
  /** Accessible name; the product name by default. */
  label?: string;
  className?: string;
}

/**
 * The product name as it appears on every Zagru surface — the app shell, the sign-in pages and e-mail previews.
 * The brand must not be redrawn, so until approved artwork is supplied (`src`) it is typographic: "Zagru" in the
 * text colour, "One" in the accent step (see `.zo-wordmark` in the design-system stylesheet). A name is not
 * mirrored: the wordmark stays left-to-right inside right-to-left pages.
 */
export function BrandWordmark({ tone = 'onLight', size = 'md', src, label = 'Zagru One', className }: BrandWordmarkProps) {
  const height = size === 'lg' ? 28 : size === 'sm' ? 18 : 22;
  if (src) return <img src={src} alt={label} height={height} className={cn('w-auto', size === 'lg' ? 'h-7' : size === 'sm' ? 'h-4.5' : 'h-5.5', className)} />;
  return (
    <span
      className={cn('zo-wordmark', `zo-wordmark--${size}`, tone === 'onDark' ? 'zo-wordmark--on-dark' : 'zo-wordmark--on-light', className)}
      aria-label={label}
      role="img"
      dir="ltr"
    >
      <span aria-hidden>Zagru</span>
      <span aria-hidden className="zo-wordmark__one">
        One
      </span>
    </span>
  );
}
